import React from 'react';
import AppImage from '@/components/ui/AppImage';

interface ConfirmationScreenProps {
  referenceNumber: string;
  villaNumber: string;
  onOrderAgain: () => void;
}

export default function ConfirmationScreen({
  referenceNumber,
  villaNumber,
  onOrderAgain,
}: ConfirmationScreenProps) {
  return (
    <main className="min-h-screen bg-background flex flex-col items-center justify-center px-6 text-center">
      <AppImage
        src="/assets/images/angna-icon-1789527716997.png"
        alt="Angna logo — arch and tulsi mark"
        width={72}
        height={72}
        className="mx-auto mb-4 opacity-90"
      />

      <div className="flex justify-center mb-3">
        <span
          className="text-3xl"
          role="img"
          aria-label="Hands joined in gratitude"
        >
          🙏
        </span>
      </div>

      <h2
        className="font-serif text-2xl font-bold mb-2"
        style={{ color: 'var(--primary)' }}
      >
        Order Received!
      </h2>

      <p className="text-sm leading-relaxed mb-4 max-w-xs" style={{ color: 'var(--muted-foreground)' }}>
        Thank you for your pre-order, Villa{' '}
        <span className="font-semibold" style={{ color: 'var(--foreground)' }}>
          {villaNumber}
        </span>
        . We&apos;ll follow up on WhatsApp to confirm your order and delivery time.
      </p>

      <div
        className="rounded-xl px-6 py-4 mb-6 border"
        style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}
      >
        <p className="text-xs font-medium mb-1" style={{ color: 'var(--muted-foreground)' }}>
          Your Reference Number
        </p>
        <p
          className="font-serif text-xl font-bold tracking-widest"
          style={{ color: 'var(--primary)' }}
        >
          {referenceNumber}
        </p>
        <p className="text-xs mt-1" style={{ color: 'var(--muted-foreground)' }}>
          Save this for your records
        </p>
      </div>

      <p className="text-xs mb-8 max-w-xs" style={{ color: 'var(--muted-foreground)' }}>
        No payment needed right now. We&apos;ll sort out the details when we reach out.
      </p>

      <button onClick={onOrderAgain} className="btn-primary text-sm px-8">
        Order More Snacks
      </button>
    </main>
  );
}